import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistor, store } from 'redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider, createTheme } from '@mui/material';

window.React = React;
const theme = createTheme({
  palette: {
    primary: {
      main: '#2ec291',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#2ec291',
            borderColor: '#2ec291',
            color: 'white',
            '&:hover': {
              backgroundColor: '#29ab80',
            },
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <PersistGate persistor={persistor}>
    <Provider store={store}>
        <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        </ThemeProvider>
    </Provider>
  </PersistGate>,
);
